import find from 'lodash/find'
import map from 'lodash/map'
import every from 'lodash/every'
import { IApplicationState } from '@Site/rootReducer'

import { createSelector } from 'reselect'

import {
  IWorkspace,
} from './types'

export const getWorkspaces = (state: IApplicationState): IWorkspace[] => state.workspaces.workspaces

export const getCurrentWorkspaceId = (state: IApplicationState) => state.workspaces.currentWorkspaceId

export const getSelectedWorkspaceIds = (state: IApplicationState) => state.workspaces.selectedWorkspaceIds

export const getSaving = (state: IApplicationState) => state.workspaces.saving

export const getHasRenamedWorkspaceSuccessfully = (state: IApplicationState) => state.workspaces.hasRenamedWorkspaceSuccessfully

export const getAllWorkspacesSelected = createSelector(
  [getSelectedWorkspaceIds, getWorkspaces],
  (selectedWorkspaceIds, workspaces) => every(workspaces, workspace => selectedWorkspaceIds.includes(workspace.id))
)

export const getCurrentWorkspace = createSelector(
  [getWorkspaces, getCurrentWorkspaceId],
  (workspaces, currentWorkspaceId) => find(workspaces, workspace => workspace.id === currentWorkspaceId)
)

export const getWorkspaceIds = createSelector(
  [getWorkspaces],
  (workspaces) => map(workspaces, workspace => workspace.id)
)

export const getCurrentWorkspaceName = createSelector(
  [getCurrentWorkspace],
  (currentWorkspace) => currentWorkspace?.attributes.name || ''
)

export const getCurrentWorkspaceNumberOfProjects = createSelector(
  [getCurrentWorkspace],
  (currentWorkspace) => currentWorkspace?.attributes.numberOfProjects || 0
)
